import React, { Fragment, useState, useEffect, Suspense, useCallback } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './components/app';
import "./i18n.js";
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './store'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { routes } from './route';
import ConfigDB from './data/customizer/config'
// import { classes } from './data/layouts';
import { createClient } from "@supabase/supabase-js";
import { toast } from 'react-toastify';
import Signin from './auth/signin'
import Invoice from './Invoice/index'
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from '@capacitor/status-bar';
import { Geolocation } from '@capacitor/geolocation';
import { Toast } from '@capacitor/toast';

import 'react-toastify/dist/ReactToastify.css';

toast.configure();



const Root = (props) => {

  const [anim, setAnim] = useState("");
  const [currentUser, setcurrentUser] = useState(window.localStorage.getItem('currentUser'));
  const [invoice, setinvoice] = useState(window.localStorage.getItem('invoice'));
  const animation = localStorage.getItem("animation") || ConfigDB.data.router_animation || 'fade'
  const [loc, setLoc] = useState(null);
  const abortController = new AbortController();
  // const defaultLayoutObj = ""
  // const layout = ""
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  const getCurrentPosition = useCallback(async () => {
    await Geolocation.getCurrentPosition().then(async (position) => {
      console.log(position.coords.latitude, position.coords.longitude);
      let { data: User_Details, error } = await supabase
        .from('User_Details')
        .update({ coordinates: `${position.coords.longitude},${position.coords.latitude}` })
        .eq('user_email', window.localStorage.getItem("useremail"))
      if (User_Details !== null) {
        await supabase
          .from('trip_details')
          .update({ driver_coordinates: `${position.coords.longitude},${position.coords.latitude}` })
          .eq('driverid', User_Details[0].user_id)

      }
      setLoc(position);
    }).catch(async (err) => {

      if (err.message == "User denied Geolocation") {
        setTimeout(() => {
          toast.error("Please Allow Location Access")

        }, 5000)
        await Toast.show({
          text: 'Please Allow Location Permission',
        });
      }
    });



  }, [loc]);



  useEffect(() => {
    if (window.localStorage.getItem("usertype") === "Driver") {
      setInterval(() => {
        getCurrentPosition();
      }, 5000)
    }

  }, [])

  async function hidesplash() {



    await SplashScreen.hide();
  }
  const setStatusBarStyleDark = async () => {
    //await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: "#211833" });
  };
  useEffect(() => {


    setInterval(() => {
      hidesplash();
    }, 1000)

    // setStatusBarStyleDark()
  }, [])
  useEffect(async () => {
    const user = supabase.auth.user();

    if (user !== null) {
      if (window.localStorage.getItem("LoggedInType") === "Mobile") {
        let { data: User_Details, error } = await supabase
          .from('User_Details')
          .select("*")
          .eq('user_phone', user.phone)

        if (User_Details !== null && User_Details.length > 0) {

          window.localStorage.setItem('currentUser', User_Details)
          // window.location.href = "/Home";
          // window.localStorage.setItem("LoggedIn", false)

        } else {

          window.localStorage.setItem('currentUser', null)
          window.localStorage.setItem("LoggedIn", true)

        }

      } else {
        let { data: User_Details, error } = await supabase
          .from('User_Details')
          .select("*")
          .eq('user_email', user.email)

        if (User_Details !== null && User_Details.length > 0) {

          window.localStorage.setItem('currentUser', User_Details)
          // window.localStorage.setItem("LoggedIn", false)
          // window.location.href = "/Home";

        } else {

          window.localStorage.setItem('currentUser', null)
          window.localStorage.setItem("LoggedIn", true)

        }

      }
    } else {

      window.localStorage.setItem('currentUser', null)
      window.localStorage.setItem("LoggedIn", false)
    }



    setAnim(animation)
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return function cleanup() {
      abortController.abort();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Suspense fallback="loading">
        <Provider store={store}>
          <BrowserRouter basename={`/`}>
            <Switch>




              {currentUser !== "null" ?
                <>
                  {invoice !== null ? <Route path={`${process.env.PUBLIC_URL}/Invoice/:id/:type`} component={Invoice} /> :
                    <App>

                      <Route exact path={`${process.env.PUBLIC_URL}/`} render={() => {
                        return (<Redirect to={`${process.env.PUBLIC_URL}/Home`} />)
                      }} />
                      <TransitionGroup>
                        {routes.map(({ path, Component }) => (
                          <Route key={path} exact path={`${process.env.PUBLIC_URL}${path}`}>
                            {({ match }) => (
                              <CSSTransition
                                in={match != null}
                                timeout={100}
                                classNames={anim}
                                unmountOnExit>
                                <div><Component /></div>
                              </CSSTransition>
                            )}
                          </Route>
                        ))}
                      </TransitionGroup>

                    </App>
                  }
                </>
                :

                <>    <Route exact path={`${process.env.PUBLIC_URL}/Invoice/:id/:type`} component={Invoice} />
                  <Route exact path={`${process.env.PUBLIC_URL}/*`} render={() => {
                    return window.location.pathname.toString().slice(0,8) == "/Invoice" ? (

                      "") : (<Redirect to={`${process.env.PUBLIC_URL}/`} />)
                  }} />
                  

                  <Route exact path={`${process.env.PUBLIC_URL}/`} component={Signin} />
                 
                 
                  
                </>


              }

            </Switch>
          </BrowserRouter>
        </Provider>
      </Suspense>
    </Fragment>
  )
}
ReactDOM.render(<Root />,
  document.getElementById('root')
);

serviceWorker.unregister();
